import { BaseAnalyticsCollection } from "./_BaseAnalyticsCollection";

export class AnalyticsGroupCollection extends BaseAnalyticsCollection<Backbone.Model> {

    url = () => {
        return window.location.origin + '/api/v1/app/' + this.appUrlRoot + '/analytic_groups';
    };

    comparator = (model) => {
        return model.get('name');
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/analytics/collections/AnalyticsGroups.ts